import HttpReq from "../../../service/httpReq"
import { PathFactory } from "../utils";
import { companyInfoListResponseSchema } from "./schemas";


class CompanyRepo {
    static publicPath = 'api/companies'
    static mgmtPath = 'api/mgmt/companies'

    static getAssetsPath(companyId, query) {
        return PathFactory.create([CompanyRepo.mgmtPath, companyId, 'assets'], query);
    }

    static list(page, successConsumer, errorConsumer) {
        HttpReq.get(
            `${CompanyRepo.publicPath}?page=${page}`,
            (response) => {
                successConsumer(companyInfoListResponseSchema.parse(response));
            },
            errorConsumer
        )
    }

    static listInternal(params, companyConsumer, errorConsumer) {
        HttpReq.get(CompanyRepo.mgmtPath + "?" + new URLSearchParams(params),
            companyConsumer, errorConsumer)
    }

    static search(name, companiesConsumer, errorConsumer) {
        HttpReq.get(CompanyRepo.publicPath + "/search?" + new URLSearchParams({ name: name }), companiesConsumer, errorConsumer)
    }

    static getInternal(id, companyConsumer, errorConsumer) {
        HttpReq.get(CompanyRepo.mgmtPath + "/" + id, companyConsumer, errorConsumer)
    }

    static get(id, companyConsumer, errorConsumer) {
        HttpReq.get(CompanyRepo.publicPath + "/" + id, companyConsumer, errorConsumer)
    }

    static save(saveCompanySpec, companyConsumer, errorConsumer) {
        HttpReq.post(CompanyRepo.mgmtPath, saveCompanySpec, companyConsumer, errorConsumer)
    }

    static update(updateCompanySpec, companyConsumer, errorConsumer) {
        HttpReq.put(CompanyRepo.mgmtPath, updateCompanySpec, companyConsumer, errorConsumer)
    }

    static getContributors(id, contributorsConsumer, errorConsumer) {
        HttpReq.get(CompanyRepo.mgmtPath + "/" + id + "/contributors", contributorsConsumer, errorConsumer)
    }

    static updateContributors(updateContributorsSpec, contributorsConsumer, errorConsumer) {
        HttpReq.put(CompanyRepo.mgmtPath + "/contributors", updateContributorsSpec, contributorsConsumer, errorConsumer)
    }

    static kpis(successConsumer, errorConsumer) {
        HttpReq.get(CompanyRepo.mgmtPath + "/kpis", successConsumer, errorConsumer)
    }

    static listAssets(companyId, successConsumer, errorConsumer) {
        HttpReq.get(CompanyRepo.getAssetsPath(companyId), successConsumer, errorConsumer);
    }

    static uploadAsset(companyId, spec, successConsumer, errorConsumer) {
        HttpReq.post(
            CompanyRepo.getAssetsPath(companyId, new URLSearchParams({ fileName: spec.fileName }).toString()),
            spec.data,
            successConsumer,
            errorConsumer,
        );
    }

    static deleteAsset(companyId, spec, successConsumer, errorConsumer) {
        HttpReq.delete(
            CompanyRepo.getAssetsPath(companyId, new URLSearchParams({ fileName: spec.fileName }).toString()),
            successConsumer,
            errorConsumer,
        );
    }
}

export default CompanyRepo